import { render } from "./vcoursewarelistedit.vue?vue&type=template&id=4437533e&scoped=true"
import script from "./vcoursewarelistedit.vue?vue&type=script&lang=js"
export * from "./vcoursewarelistedit.vue?vue&type=script&lang=js"

import "./vcoursewarelistedit.vue?vue&type=style&index=0&id=4437533e&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4437533e"]])

export default __exports__